const queryTransactions = `
	query transactions($limit: Int, $skip: Int, $sort: sortInput, $where: transactionWhereInput){
		transactions(limit: $limit, skip: $skip, sort: $sort, where: $where) {
			totalCount
			list{
				id
				amount
				method
				status
				dateTime
				formattedTransaction
				currencyCode
				transactionNumber
				object{
					__typename
					... on policy {
						id
						issuerNumber
					}
					... on claim {
						id
						issuerNumber
					}
					... on proposal {
						id
						name
					}
					... on endorsement {
						id
						endorsementDate
						policy {
							id
							issuerNumber
						}
					}
				}
			}
		}
	}`

const queryTransactionDetail = `
query transactions($limit: Int, $skip: Int, $sort: sortInput, $where: transactionWhereInput){
	transactions(limit: $limit, skip: $skip, sort: $sort, where: $where) {
		list{
			id
			method
			status
			dateTime
			formattedTransaction
			currencyCode
			transactionNumber
			createdAt
			postDateTime
			dueDateTime
			lastModifiedAt
			createdBy {
				username
			}
			lastModifiedBy {
				username
			}
			facts {
				id
				type
				value {
				  stringValue
				  numberValue
				  booleanValue
				  dateValue
				  arrayValue {
					stringValue
				  }
				  objectValue {
					key
					value{
					  stringValue
					  numberValue
					  booleanValue
					  dateValue
					}
				  }
				}
			}
			object{
				__typename
				... on policy {
					id
					issuerNumber
				}
				... on claim {
					id
					issuerNumber
				}
				... on proposal {
					id
					name
					case {
						id
					}
				}
				... on endorsement {
					id
					endorsementDate
					policy {
						id
						issuerNumber
					}
				}
			}
		}
	}
}`

const queryPolicies = `
	query policies($where: policyWhereInput, $sort: sortInput, $limit: Int) {
		policies (where: $where, sort: $sort, limit: $limit) {
			totalCount
			list {
				id
				issuerNumber
				endorsements {
					id
					endorsementDate
				}
			}
		}
	}`

const queryClaims = `
	query claims($where: claimWhereInput, $sort: sortInput, $limit: Int) {
		claims (where: $where, sort: $sort, limit: $limit) {
			totalCount
			list {
				id
				issuerNumber
			}
		}
	}`

const queryProposals = `
	query proposals ($limit: Int, $caseWhere: caseWhere, $proposalsWhere: proposalWhere) {
		proposals:cases (where: $caseWhere, limit: $limit) {
			list {
				proposals(where: $proposalsWhere) {
					name
					id
				}
			}
		}
	}`

const addTransaction = `
	mutation createTransaction($input: createTransactionInput!) {
		createTransaction (input: $input) {
			errors
			status
		}
	}`
const updateTransaction = `
	mutation updateTransaction($transactionId: String!, $input: updateTransactionInput!) {
		updateTransaction (transactionId: $transactionId, input: $input) {
			status
			errors
		}
	}
`
const addFactToTransaction = `
	mutation addFactToTransaction($transactionId: String!, $input: addFactInput!) {
		addFactToTransaction(transactionId: $transactionId, input: $input) {
			status
			errors
		}
	}
`

const updateTransactionFact = `
	mutation updateTransactionFact($transactionId: String!, $factId: String!, $input: updateFactInput!) {
		updateTransactionFact(transactionId: $transactionId, factId: $factId, input: $input) {
			status
			errors
		}
	}
`

const removeFactFromTransaction = `
	mutation removeFactFromTransaction($transactionId: String!, $factId: String!) {
		removeFactFromTransaction(transactionId: $transactionId, factId: $factId) {
			status
			errors
		}
	}
`

const deleteTransaction = `
	mutation deleteTransaction ($transactionId: String!) {
		deleteTransaction (transactionId: $transactionId) {
			status
			errors
		}
	}
`

export {
	queryTransactions,
	queryTransactionDetail,
	queryPolicies,
	queryClaims,
	queryProposals,
	addTransaction,
	updateTransaction,
	addFactToTransaction,
	updateTransactionFact,
	removeFactFromTransaction,
	deleteTransaction
}
